import * as React from 'react';

import { Translate } from '@decorators';

import { FileUploader } from '@common/components/FileUploader';
import { MultilineText } from '@common/components/MultilineText';
import { FormRow, Input } from '@common/components/ui';

import { IDmcaCaseProps } from './types';

import * as s from './DmcaCase.scss';

@Translate('common.containers.Dmca.components.DmcaCase')
export class DmcaCase extends React.Component<IDmcaCaseProps> {

	onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const {
			target: {
				value,
				name,
			},
		} = event;
		const { onChange } = this.props;

		onChange({ [name]: value });
	};

	onFileUploadCancel = () => {
		const {
			onFileUploadCancel,
		} = this.props;

		onFileUploadCancel();
	};

	onFileUploadError = (error: Error) => {
		const {
			onFileUploadError,
		} = this.props;

		onFileUploadError(error);
	};

	onFileUploadSuccess = () => {
		const {
			onFileUploadSuccess,
		} = this.props;

		onFileUploadSuccess();
	};

	render() {
		const {
			files,
			description,
			confirmation,
			errorFields,
			onFilesAdd,
			onFileRemove,
			onFileUpload,
		} = this.props;

		return (
			<div className={s.block}>
				<FormRow className={s.formRow}>
					<Input
						rows={5}
						isValid={!errorFields.includes('description')}
						label={this.t('description.label')}
						value={description}
						name="description"
						placeholder={this.t('description.placeholder')}
						onChange={this.onChange}
					/>
				</FormRow>

				<FormRow className={s.formRow}>
					<Input
						rows={5}
						isValid={!errorFields.includes('confirmation')}
						label={this.t('confirmation.label')}
						value={confirmation}
						name="confirmation"
						placeholder={this.t('confirmation.placeholder')}
						onChange={this.onChange}
					/>
				</FormRow>

				<FileUploader
					classNames={{
						block: s.fileUploader,
					}}
					title={this.t('fileButtonTitle')}
					files={files}
					isFilesNotReadyError={errorFields.includes('files')}
					onFileRemove={onFileRemove}
					onFilesAdd={onFilesAdd}
					onFileUpload={onFileUpload}
					onFileUploadCancel={this.onFileUploadCancel}
					onFileUploadError={this.onFileUploadError}
					onFileUploadSuccess={this.onFileUploadSuccess}
				/>

				<div className={s.explanation}>
					<MultilineText text={this.t('explanation')} />
				</div>
			</div>
		);
	}

}
